export default "__VITE_ASSET__CvsLcvYb__"